import { useState } from 'react';

import { RiPulseLine } from '@remixicon/react';

import { Button } from '@backstage/ui';

import type { SaveToPulseInput } from '../../types';
import { SaveToPulseDialog } from '../SaveToPulseDialog';

type SaveToPulseButtonProps = {
  input: SaveToPulseInput;
};

export const SaveToPulseButton = ({ input }: SaveToPulseButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        size="small"
        iconStart={<RiPulseLine size={16} />}
        onPress={() => setDialogOpen(true)}
      >
        Add to pulse
      </Button>
      {dialogOpen && (
        <SaveToPulseDialog
          isOpen={dialogOpen}
          onOpenChange={setDialogOpen}
          input={input}
        />
      )}
    </>
  );
};
